import { createI18n } from "vue-i18n";
import ptBR from "./locales/pt-BR";
import enUS from "./locales/en-US";
import esES from "./locales/es-ES";
import frFR from "./locales/fr-FR";

const i18n = createI18n({
	legacy: false,
	locale: localStorage.getItem("locale") || "pt-BR", // Usa idioma do localStorage ou padrão
	fallbackLocale: "pt-BR",
	messages: {
		"pt-BR": ptBR,
		"en-US": enUS,
		"es-ES": esES,
		"fr-FR": frFR,
	},
});

export default i18n;
